<template>
  <div class="photo" ref="imageTest">
    <!-- logo -->
    <img src="@/assets/1/logo2.png" class="logo" />
    <div id="capture">
      <div v-if="type == 1">
        <img src="@/assets/6/bg1-1.jpg" class="bg" />
        <img src="@/assets/6/bg1.png" class="bg bg2" />
      </div>
      <div v-if="type == 2">
        <img src="@/assets/6/bg2-1.jpg" class="bg" />
        <img src="@/assets/6/bg2.png" class="bg bg2" />
      </div>
      <div class="er">
        <img src="@/assets/6/er.png" />
        <div>分享给好友一起玩</div>
      </div>
      <div class="imgRe">
        <img src="@/assets/6/img.png" class="img1" />
        <img src="@/assets/6/img-1.png" class="img2" v-if="img2" />
        <div id="pic" class="backIcon">
          <img class="head" :src="head" />
        </div>
      </div>
      <!-- 点击拍照 -->
      <img src="@/assets/6/dian.png" class="dian" v-if="dian" />
      <van-uploader :after-read="afterRead" class="upload" v-if="canvasUrl">
        <img src="@/assets/6/photo.png" class="photoImg" />
      </van-uploader>
      <div @click="htmlToCanvas" v-if="dianUrl" class="heBtn">
        <img src="@/assets/6/he.png" />
      </div>
      <div class="mask" v-if="canvasImageUrl != ''">
        <img :src="canvasImageUrl" class="canvasImageUrl" />
        <div class="text">— 长按图片保存转发朋友圈 —</div>
        <div @click="toUrl" class="tiaozhuan">
          <img src="@/assets/6/tiao.png" />
        </div>
      </div>
    </div>
    <!-- <van-uploader v-model="fileList" multiple :max-count="1" /> -->
  </div>
</template>
<script>
import { Uploader, Button } from "vant";
import html2canvas from "html2canvas";
export default {
  components: {
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    html2canvas,
  },
  data() {
    return {
      type: "",
      dian: true,
      dianS: true,
      imgList: [],
      head: "",
      img2: true,
      canvasImageUrl: "",
      canvasUrl: true,
      dianUrl: false,
      position: { x: 0, y: 0 },
      cx: "",
      cy: "",
      x: "",
      y: "",
      l: "",
      t: "",
      r: "",
      b: "",
    };
  },
  mounted() {
    let type = this.$route.query.type;
    this.type = type;
    setTimeout(() => {
      this.dianS = false;
      this.dian = false;
    }, 5000);
    setInterval(() => {
      if (this.dianS) {
        this.dian = !this.dian;
      }
    }, 300);
    let moveDiv = document.querySelector("#pic");
    this.w = document.documentElement.clientWidth || document.body.clientWidth;
    this.h =
      document.documentElement.clientHeight || document.body.clientHeight;
    this.x = moveDiv.offsetWidth;
    this.y = moveDiv.offsetHeight;
    //使用二级事件绑定，解决浏览器警告，可自行查询
    moveDiv.addEventListener("touchstart", this.down, { passive: false });
    moveDiv.addEventListener("touchmove", this.move, { passive: false });
    moveDiv.addEventListener("touchend", this.end, { passive: false });
    //可移动边界判断
    this.l = moveDiv.offsetLeft;
    this.t = moveDiv.offsetTop;
    this.r = this.w - this.l - this.x;
    this.b = this.h - this.t - this.y;
  },
  methods: {
    afterRead(file) {
      console.log(file);
      let head = file.content;
      this.head = head;
      this.img2 = false;
      this.dianUrl = true;
    },
    htmlToCanvas() {
      this.canvasUrl = false;
      this.dianUrl = false;
      setTimeout(() => {
        html2canvas(this.$refs.imageTest, {
          allowTaint: true,
          useCORS: true,
        }).then((canvas) => {
          let imageUrl = canvas.toDataURL("image/jpeg"); // 将canvas转成base64图片格式
          this.canvasImageUrl = imageUrl;
        });
      }, 10);
    },
    toJie() {
      html2canvas(document.querySelector("#capture")).then((canvas) => {
        const imgUrl = canvas.toDataURL("png"); // 获取生成的图片的url
        console.log(imgUrl);
        this.saveFile(imgUrl, "555");
      });
    },
    saveFile(data, filename) {
      var save_link = document.createElementNS(
        "http://www.w3.org/1999/xhtml",
        "a"
      );
      save_link.href = data;
      save_link.download = filename;

      var event = document.createEvent("MouseEvents");
      event.initMouseEvent(
        "click",
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      );
      save_link.dispatchEvent(event);
    },
    toUrl() {
      this.$router.push("/end");
    },
    // 实现移动端拖拽
    down(event) {
      console.log(555);
      let moveDiv = document.querySelector("#pic");
      this.position.x = moveDiv.offsetLeft;
      this.position.y = moveDiv.offsetTop;
      let touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      //光标起始位置
      this.cx = touch.clientX;
      this.cy = touch.clientY;
    },
    move(event) {
      let moveDiv = document.querySelector("#pic");
      let touch;
      if (event.touches) {
        touch = event.touches[0];
      } else {
        touch = event;
      }
      event.preventDefault(); //阻止body滚动
      //光标偏移量
      this.curx = touch.clientX - this.cx;
      this.cury = touch.clientY - this.cy;
      //DOM 运动边界判断
      if (this.curx > 0) {
        //向右
        this.curx = Math.abs(this.curx) > this.r ? this.r : this.curx;
      } else {
        //向左
        this.curx = Math.abs(this.curx) > this.l ? -this.l : this.curx;
      }
      if (this.cury > 0) {
        //向下
        this.cury = Math.abs(this.cury) > this.b ? this.b : this.cury;
      } else {
        //向上
        this.cury = Math.abs(this.cury) > this.t ? -this.t : this.cury;
      }
      //DOM 运动
      moveDiv.style.transform = `translate(${this.curx}px,${this.cury}px)`;
    },
    end() {
      let moveDiv = document.querySelector("#pic");
      //光标松开,记录盒子的位移。
      let aa = parseInt(moveDiv.style.transform.match(/(-?\d+\.?\d+)/g)[0]); //获取X偏移量
      let bb = parseInt(moveDiv.style.transform.match(/(-?\d+\.?\d+)/g)[1]); //获取Y偏移量
      let ax = parseInt(this.position.x) + aa; //DOMX轴偏移量
      let by = parseInt(this.position.y) + bb; //DOMY轴偏移量
      // 处理吸边
      //ax = ax>this.w/2?this.w-this.x:0;
      //end 时，重绘DOM位置，并清空transform的值。
      moveDiv.style.left = ax + "px";
      moveDiv.style.top = by + "px";
      moveDiv.style.transform = "";
      //可移动边界判断
      this.l = ax;
      this.t = by;
      this.r = this.w - this.l - this.x;
      this.b = this.h - this.t - this.y;
    },
  },
};
</script>
<style scoped>
.logo {
  top: 0;
  left: 0;
  width: 60%;
}
.bg {
  position: absolute;
  z-index: -2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
/* #pic {
  width: 60vw;
  height: 39vw;
 }
.head {
  width:54vw;
  position: absolute;
  min-height: 39vw;
  left: 24vw;
  top: 13vw;
  z-index: 0;
} */
/* #pic {
  width: 200px;
  height: 200px;
} */
/* #pic img {
  width: 50%;
  height: 50%;
} */
.backIcon {
  position: absolute;
  width: 54vw;
  /* position: absolute; */
  min-height: 39vw;
  left: 24vw;
  top: 14vw;
  z-index: 0;
}
.backIcon img {
  width: 100%;
  min-height: 39vw;
}
.upload {
  position: absolute;
  bottom: 25%;
  left: 40%;
  z-index: 2;
}
.photoImg {
  width: 20vw;
}
#capture {
  width: 100%;
  height: 100vh;
}
.imgRe {
  position: absolute;
  bottom: 12%;
  left: 0;
  /* z-index: -1; */
  width: 100%;
  height: 56vh;
}
.imgRe .img1 {
  width: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
}
.imgRe .img2 {
  width: 49%;
  position: absolute;
  top: 15%;
  left: 26%;
}
.bg2 {
  z-index: 2;
  top: 7%;
}
.dian {
  position: absolute;
  width: 40vw;
  right: 0;
  bottom: 30%;
  z-index: 2;
}
.mask {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: #000000a8;
  z-index: 50;
  height: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.canvasImageUrl {
  width: 72%;
  z-index: 50;
}
.mask .text {
  width: 100%;
  color: white;
  position: absolute;
  top: 16vw;
  text-align: center;
  text-shadow: 1px 1px 1px #5c24d5;
  font-weight: bold;
}
.mask .tiaozhuan {
  position: absolute;
  bottom: 12vw;
  width: 40%;
  left: 30%;
}
.mask .tiaozhuan img {
  width: 100%;
}
.heBtn {
  position: absolute;
  bottom: 20vw;
  z-index: 2;
  width: 50%;
  left: 25%;
}
.heBtn img {
  width: 100%;
  animation: mymove 3s infinite;
  -webkit-animation: mymove 3s infinite; /*Safari and Chrome*/
  animation-direction: alternate; /*轮流反向播放动画。*/
  animation-timing-function: ease-in-out; /*动画的速度曲线*/
  /* Safari 和 Chrome */
  -webkit-animation: mymove 3s infinite;
  -webkit-animation-direction: alternate; /*轮流反向播放动画。*/
  -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
}
@keyframes mymove {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}

@-webkit-keyframes mymove /*Safari and Chrome*/ {
  0% {
    transform: scale(1); /*开始为原始大小*/
  }
  25% {
    transform: scale(1.1); /*放大1.1倍*/
  }
  50% {
    transform: scale(1);
  }
  75% {
    transform: scale(1.1);
  }
}
.er {
  width: 30vw;
  right: 5vw;
  position: absolute;
  top: 26vw;
  color: white;
  font-size: 12px;
  text-shadow: 1px 1px 1px #4e08ea;
  font-weight: bold;
  text-align: center;
}
.er img {
  width: 27vw;
}
</style>


// WEBPACK FOOTER //
// src/pages/photo/photo.vue